import React from 'react';

const SaveHeartButton = ({
  isSaved = false,
  onClick,
  disabled = false,
  className = '',
}) => {
  const handleClick = (event) => {
    event.stopPropagation();
    if (onClick) {
      onClick(event);
    }
  };

  return (
    <button
      type="button"
      aria-label={isSaved ? 'Unsave video' : 'Save video'}
      onClick={handleClick}
      disabled={disabled}
      className={`w-8 h-8 p-1 rounded-lg flex items-center justify-center ${
        isSaved
          ? 'border border-red-300 bg-red-50 text-red-500'
          : 'text-gray-500 hover:bg-gray-200'
      } ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'} ${className}`}
    >
      <svg
        viewBox="0 0 24 24"
        className="w-4 h-4"
        fill={isSaved ? 'currentColor' : 'none'}
        stroke="currentColor"
        strokeWidth="2"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M11.995 20.5c-5.5-3.5-8.5-6.7-8.5-10.1 0-2.4 1.9-4.3 4.3-4.3 1.5 0 2.9.8 3.7 2.1.8-1.3 2.2-2.1 3.7-2.1 2.4 0 4.3 1.9 4.3 4.3 0 3.4-3 6.6-8.5 10.1z"
        />
      </svg>
    </button>
  );
};

export default SaveHeartButton;
